import { useState, useEffect } from 'react';
import { Gamepad2, Trophy, Zap, Coffee } from 'lucide-react';
import axios from 'axios';
import { API } from '@/App';

function Sidebar() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Fetching sidebar data from:', `${API}/stats/categories`);
        const categoriesRes = await axios.get(`${API}/stats/categories`);
        
        console.log('Categories response:', categoriesRes.data);
        
        setCategories(categoriesRes.data);
      } catch (error) {
        console.error('Error fetching sidebar data:', error);
        console.error('Error details:', error.response?.data);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Icon mapping for categories
  const getCategoryIcon = (categoryName) => {
    const iconMap = {
      'RPG': Gamepad2,
      'FPS': Zap,
      'Reviews': Trophy,
      'Hardware': Trophy,
      'Indie': Gamepad2,
      'Esports': Trophy,
    };
    return iconMap[categoryName] || Gamepad2;
  };

  // Color mapping for categories
  const getCategoryColor = (index) => {
    const colors = [
      'text-blue-500',
      'text-red-500',
      'text-yellow-500',
      'text-green-500',
      'text-purple-500',
      'text-orange-500'
    ];
    return colors[index % colors.length];
  };

  return (
    <div className="hidden lg:block w-80 sticky top-20 h-fit space-y-6">
      {/* Buy Me a Coffee Box */}
      <div className="bg-gradient-to-br from-purple-600 to-blue-600 rounded-lg p-6 text-white text-center">
        <Coffee className="w-8 h-8 mx-auto mb-3" />
        <h3 className="font-bold text-lg mb-2">Love GameFeed?</h3>
        <p className="text-sm opacity-90 mb-4">Support us to keep bringing you the best gaming news!</p>
        <button
          onClick={() => window.open('https://paypal.me/jschoes1994?locale.x=en_US&country.x=US', '_blank')}
          className="w-full bg-white text-purple-600 font-semibold py-2 px-4 rounded-lg hover:bg-gray-100 transition-colors flex items-center justify-center gap-2"
        >
          <Coffee className="w-4 h-4" />
          Buy me a Coffee
        </button>
      </div>

      {/* Popular Categories */}
      <div className="article-card bg-card border border-border rounded-lg p-4">
        <h3 className="font-bold text-lg mb-4 flex items-center gap-2">
          <Gamepad2 className="w-5 h-5 text-primary" />
          Popular Categories
        </h3>
        {loading ? (
          <div className="text-center py-4 text-muted-foreground">Loading...</div>
        ) : categories.length > 0 ? (
          <div className="space-y-3">
            {categories.map((category, index) => {
              const Icon = getCategoryIcon(category.name);
              const color = getCategoryColor(index);
              return (
                <button
                  key={category.name}
                  className="w-full flex items-center justify-between p-2 rounded-lg hover:bg-accent transition-colors text-left"
                  data-testid={`category-${category.name}`}
                >
                  <div className="flex items-center gap-3">
                    <Icon className={`w-4 h-4 ${color}`} />
                    <span className="font-medium">{category.name}</span>
                  </div>
                  <span className="text-sm text-muted-foreground">{category.count}</span>
                </button>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-4 text-muted-foreground text-sm">No categories yet</div>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
